'use strict';
define(['angular','jquery'], function (ng,$) {
    function SEOCheckerResultsCtrl(__env, FavIconService,$rootScope, stLimitMessage, $scope, $window, $state, $timeout, $interval, $stateParams, SeocheckerService, ReportPdfService, userInfo, LanguageService, TrackEventService, $mdMedia) {
        var vm = $scope;
        vm.$mdMedia = $mdMedia;
        vm.getFavIcon = FavIconService.get;
        vm.isAuthenticated = userInfo && userInfo.account && userInfo.account !== 'offline';
        vm.canDoTrial = userInfo.canDoTrial;
        vm.trialPeriodDays = __env.trialPeriodDays || 7;
        vm.badUrl = false;
        vm.searchInputIsFocused = false;
        vm.loading = true;
        var loadingAgentTimer = null;
        var loadingAgentStep = 0;
        var loadingAgentRowHeight = 34;
        var loadingAgentActiveRow = 2;

        vm.messages = {
            messageWhenEmptyDataTitle: null, messageWhenEmptyDataSubtitle: null, messageWhenEmptyDataIcon: null, messageWhenEmptyDataCta: null
        };
        vm.emailUser = userInfo.email;
        vm.userInfo = userInfo;
        vm.currentUser = userInfo;
        vm.$state = $state;

        vm.resultTabs = [
            {value: 'overview', label: 'seochecker.overview', icon: 'ti-layout-dashboard'},
            {value: 'aeo', label: 'seochecker.seoGeo', icon: 'ti-sparkles'},
            {value: 'structure', label: 'seochecker.base', icon: 'ti-file-search'},
            {value: 'content', label: 'seochecker.content', icon: 'ti-file-text'},
            {value: 'speed', label: 'seochecker.performance', icon: 'ti-gauge'},
            {value: 'social', label: 'seochecker.social', icon: 'ti-share'}
        ];
        vm.loadingAgentChecks = [
            // Base, URL e indicizzazione
            'Verifico che l\'anteprima Google mostri title, URL e descrizione corretti',
            'Verifico che il title sia presente, univoco e abbia la lunghezza giusta',
            'Verifico che la meta description sia presente e descriva bene la pagina',
            'Verifico che la favicon sia presente e raggiungibile',
            'Verifico che l\'URL sia leggibile, breve e ottimizzato',
            'Verifico che i dati strutturati aiutino i motori a capire la pagina',
            'Verifico che non ci siano tag HTML obsoleti',
            'Verifico che la sitemap sia presente e correttamente formattata',
            'Verifico che robots.txt permetta di scansionare le pagine giuste',
            'Verifico che la connessione al sito sia protetta con HTTPS',
            'Verifico che gli iframe non nascondano contenuti importanti',
            'Verifico che il title sia coerente con il contenuto della pagina',
            'Verifico che la pagina definisca correttamente il viewport',
            'Verifico che il meta viewport sia adatto ai dispositivi mobili',
            'Verifico che il documento usi un doctype HTML5 valido',
            'Verifico che gli event listener passivi non blocchino lo scroll',
            'Verifico che la pagina possa essere scansionata dai motori di ricerca',
            'Verifico che i link siano scansionabili e portino a destinazioni valide',
            'Verifico che il canonical indichi la versione corretta della pagina',
            'Verifico che non ci siano contenuti misti o risorse non sicure',
            'Verifico che non siano presenti librerie JavaScript vulnerabili',
            'Verifico che il sito utilizzi HTTP/2',
            'Verifico che i link esterni usino rel noopener',
            'Verifico che la pagina dichiari la lingua principale',
            'Verifico che il codice della lingua sia valido',
            'Verifico che gli hreflang colleghino le versioni linguistiche',

            // Contenuti, heading, immagini e link
            'Verifico che la pagina contenga abbastanza testo utile',
            'Verifico che il testo sia ben bilanciato rispetto al codice HTML',
            'Verifico che non ci siano H1 duplicati o mancanti',
            'Verifico che gli H2 organizzino i contenuti in modo chiaro',
            'Verifico che l\'H1 sia coerente con title e argomento della pagina',
            'Verifico che i link abbiano un titolo descrittivo quando serve',
            'Verifico che l\'URL contenga la parola chiave principale',
            'Verifico che i link abbiano testi chiari e descrittivi',
            'Verifico che tutte le immagini abbiano un alt text utile',
            'Verifico che i plugin non limitino accessibilità e leggibilità',
            'Verifico che la gerarchia dei heading sia corretta',

            // Condivisione social
            'Verifico che i metadati Open Graph siano completi',
            'Verifico che la Twitter Card sia configurata correttamente',
            'Verifico che i plugin social non rallentino la pagina',
            'Verifico la popolarità e la presenza social della pagina',

            // Performance e Core Web Vitals
            'Verifico che il Largest Contentful Paint sia veloce',
            'Verifico che il Cumulative Layout Shift sia stabile',
            'Verifico che il First Contentful Paint mostri presto i primi contenuti',
            'Verifico che il Time to Interactive sia breve',
            'Verifico che lo Speed Index indichi un caricamento rapido',
            'Verifico che il Total Blocking Time non blocchi l\'interazione',

            // Scopribilità per agenti AI
            'Verifico che robots.txt descriva la scansione per gli agenti AI',
            'Verifico che la sitemap aiuti gli agenti AI a scoprire le pagine',
            'Verifico che gli header Link indichino risorse utili agli agenti',
            'Verifico che DNS-AID permetta agli agenti di scoprire i servizi',
            'Verifico che il sito possa restituire i contenuti in Markdown',

            // Accesso e regole per i bot AI
            'Verifico che le regole per i crawler AI siano esplicite e coerenti',
            'Verifico che Content Signals dichiari l\'uso dei contenuti per l\'AI',
            'Verifico che Web Bot Auth permetta di verificare le richieste dei bot',

            // API, autenticazione, MCP e skill
            'Verifico che il catalogo API descriva i servizi disponibili',
            'Verifico che la scoperta OAuth/OIDC spieghi come autenticarsi',
            'Verifico che i metadati OAuth descrivano le risorse protette',
            'Verifico che auth.md spieghi come registrare un agente',
            'Verifico che la MCP Server Card descriva server e capacità',
            'Verifico che la A2A Agent Card permetta la scoperta tra agenti',
            'Verifico che l\'indice Agent Skills elenchi le capacità operative',
            'Verifico che WebMCP esponga le azioni del sito agli agenti',
            'Verifico che il manifest ARD descriva le risorse agentiche',
            'Verifico che il manifest Poppy abiliti gli agenti personali',

            // Commercio agentico
            'Verifico che x402 permetta pagamenti HTTP nativi per agenti',
            'Verifico che MPP esponga i metadati dei pagamenti per agenti',
            'Verifico che UCP descriva servizi e capacità di commercio',
            'Verifico che ACP descriva l\'API di commercio per agenti',
            'Verifico che AP2 sia configurato per i pagamenti avviati dagli agenti'
        ];
        vm.loadingAgentMessages = [];
        vm.loadingAgentOffset = 0;
        vm.activeResultTab = 'overview';
        vm.currentNavItem = 0;
        vm.selectResultTab = function (value) {
            if (value === vm.activeResultTab) {
                return;
            }
            $state.go('app.seochecker.results.' + value);
        };

        function syncActiveResultTab() {
            if ($state.includes('app.seochecker.results.aeo')) {
                vm.activeResultTab = 'aeo';
            } else if ($state.includes('app.seochecker.results.social')) {
                vm.activeResultTab = 'social';
            } else if ($state.includes('app.seochecker.results.speed')) {
                vm.activeResultTab = 'speed';
            } else if ($state.includes('app.seochecker.results.content')) {
                vm.activeResultTab = 'content';
            } else if ($state.includes('app.seochecker.results.structure')) {
                vm.activeResultTab = 'structure';
            } else {
                vm.activeResultTab = 'overview';
            }
            vm.currentNavItem = vm.resultTabs.map(function (tab) {
                return tab.value;
            }).indexOf(vm.activeResultTab);
        }

        syncActiveResultTab();
        $scope.$on('$stateChangeSuccess', syncActiveResultTab);
        $timeout(syncActiveResultTab, 0);

        //In this case we pass the only code language to google for API service
        var languageCodeSaveOnStorage = LanguageService.getLanguageCodeSaveOnStorage();

        var userData = {};

        if ($window.localStorage.getItem('ngStorage-currentUser')) {
            userData = JSON.parse($window.localStorage.getItem('ngStorage-currentUser'));
        }

        var analysis = {
            url: null
        };

        try {
            analysis.url = atob(decodeURIComponent($stateParams.url));
        } catch (err) {
            analysis.url = '';
        }

        $scope.analysis = analysis;
        if ($scope.analysis.url.trim() == "") {
            $state.go('app.seochecker.landing');
        }

        $scope.lastQuery = ng.copy($scope.analysis.url);
        $scope.urlInAction = encodeURIComponent(btoa($scope.analysis.url));

        var correctUrlRegex = new RegExp(/^((http:\/\/|https:\/\/)?(www\.|^\.)?((([\-|\wæÆØøÅå|\d]+)\.)+([a-zA-ZæÆØøÅå]{1,10}))(\/?(([a-zA-ZZæÆØøÅå0-9_@]+\.([a-zA-ZZæÆØøÅå0-9]{3,6}))?(\??[-A-Za-zæÆØøÅå0-9+:&@#\/%=~'_\.?|]+))){0,1})$/gim);

        $scope.newAnalysis = function () {

            if (!$scope.analysis || !$scope.analysis.url) {
                return;
            }

            if ($scope.typeOfAnalysis === 'seo-spider') {
                $state.go('app.project.wizard', {url:$scope.analysis.url, from: 'seo-checker-landing', step: 'create-project'});
                return;
            }


            if ($scope.lastQuery === $scope.analysis.url) {
                $scope.restartAnalysis();
                return;
            }

            $state.go('app.seochecker.results.overview', {
                url: encodeURIComponent(btoa($scope.analysis.url)), 'open-dialog': null
            }, {
                notify: true,
                reload: true
            });

            $scope.lastQuery = ng.copy($scope.analysis.url);
        };

        $scope.restartAnalysis = function () {
            if (!$scope.analysis || !$scope.analysis.url || $scope.loading) {
                return;
            }

            $scope.analysis.url = $scope.analysis.url.trim();
            $scope.loading = true;
            $scope.badUrl = false;
            $scope.urlInAction = encodeURIComponent(btoa($scope.analysis.url));
            $scope.lastQuery = ng.copy($scope.analysis.url);
            seocheckerAudit();
        };

        $scope.seochecker = function () {
            var isValidSearch = ($scope.analysis.url != undefined && $scope.analysis.url.length != 0 && $scope.analysis.url.match(correctUrlRegex));

            if (isValidSearch) $state.go('app.seochecker.results.overview', {
                url: encodeURIComponent(btoa($scope.analysis.url))
            }); else $state.go('app.seochecker.landing');
        };

        seocheckerAudit();

        function seocheckerAudit() {
            resetCategoryIssueCounts();
            startLoadingAgent();
            $scope.reportConfiguration = {
                config: {
                    version: "1.0", params: {
                        url: $scope.analysis.url.trim(), locale: languageCodeSaveOnStorage, email: {
                            to: userData ? userData.email : ''
                        }, categories: ReportPdfService.getCategories({
                            type: 'seo_checker', score: true, preview: true, suggests: true, problems: true
                        })
                    }, default: true,
                }, type: "seo_checker", data: {}
            };
            setMessages();

            SeocheckerService.audit($scope.analysis.url)
                .then(function (res) {
                    if (res.audit.error) {
                        $scope.badUrl = true;
                    }

                    var audit = {
                        base: {}, content: {}, social: {}, categories: {}, aeo: null,
                    };
                    if (res.audit) {
                        audit = res.audit;
                    }

                    var performance = {
                        desktop: {}, mobile: {},
                    };
                    if (res.performance && res.performance.desktop && res.performance.mobile) {
                        performance = res.performance;
                    }

                    var overview = {};
                    if (res.overview) {
                        overview = res.overview;
                    }

                    TrackEventService.event('Suite Usages', 'SEO Checker - Audit');
                    TrackEventService.gaV2Event('seo_audit', {
                        type: "URL", tool: "SEO Checker"
                    });

                    $scope.loading = false;
                    stopLoadingAgent();
                    syncActiveResultTab();

                    // Set all results from exams
                    $scope.base = audit.base;
                    $scope.content = audit.content;
                    $scope.social = audit.social;
                    $scope.aeo = audit.aeo;
                    $scope.overview = overview;
                    $scope.performance = performance;
                    updateCategoryIssueCounts(audit, performance);

                    // Calculate and set score on "$scope.score" variable
                    setGlobalScore();

                    // Set categories to format all tabs
                    if (audit.categories.base) {
                        $scope.baseCategories = audit.categories.base;
                    }

                    if (audit.categories.content) {
                        $scope.contentCategories = audit.categories.content;
                    }

                    if ($scope.reportConfiguration) {
                        $scope.reportConfiguration.data = {
                            base: Object.assign({}, audit.base),
                            content: Object.assign({}, audit.content),
                            social: Object.assign({}, audit.social),
                            aeo: Object.assign({}, audit.aeo),
                            overview: Object.assign({}, audit.overview),
                            performance: performance,
                            score: $scope.score,
                        }
                    }

                    if ($stateParams['open-dialog']) {
                        $scope.openReportDialog();
                    }
                })
                .catch(function (err) {
                    $scope.loading = false;
                    $scope.badUrl = true;
                    stopLoadingAgent();
                    if (err.status === 429 || err.status === 426) {
                        setMessages(stLimitMessage.getFromError(err, userInfo).title, stLimitMessage.getFromError(err, userInfo).subtitle, stLimitMessage.getFromError(err, userInfo).icon, stLimitMessage.getFromError(err, userInfo).cta,);
                    }

                });
        }

        $scope.openReportDialog = function () {
            $timeout(function () {
                $(document.querySelector('#report-pdf-button')).click();
            });
        };

        function setMessages(title, subtitle, icon, cta) {
            $scope.messages.messageWhenEmptyDataTitle = title || null;
            $scope.messages.messageWhenEmptyDataSubtitle = subtitle || null;
            $scope.messages.messageWhenEmptyDataIcon = icon || null;
            $scope.messages.messageWhenEmptyDataCta = cta || null;
        }

        $rootScope.$on('languageChanged', function (event, lang) {
            var data = $scope.reportConfiguration.data;
            $scope.reportConfiguration = {
                "config": {
                    "version": "1.0", "params": {
                        "url": $scope.analysis.url.trim(), "locale": languageCodeSaveOnStorage, "email": {
                            "to": userData ? userData.email : ''
                        }, "categories": ReportPdfService.getCategories({
                            type: 'seo_checker', score: true, preview: true, suggests: true, problems: true
                        })
                    }, "default": true
                }, "type": "seo_checker", data: data,
            };
        });

        function setGlobalScore() {
            var sum = 0;
            sum += Number($scope.base.score || 0);
            sum += Number($scope.social.score || 0);
            sum += Number($scope.content.score || 0);
            sum += Number($scope.performance.desktop.score || 0);
            sum += Number($scope.performance.mobile.score || 0);
            sum += Number($scope.aeo && $scope.aeo.score || 0);
            var examLen = 0;
            examLen += Number($scope.base.score ? 1 : 0);
            examLen += Number($scope.social.score ? 1 : 0);
            examLen += Number($scope.content.score ? 1 : 0);
            examLen += Number($scope.performance.desktop.score ? 1 : 0);
            examLen += Number($scope.performance.mobile.score ? 1 : 0);
            examLen += Number($scope.aeo && typeof $scope.aeo.score === 'number' ? 1 : 0);
            $scope.score = examLen > 0 ? (parseFloat((sum) / examLen)).toFixed(1) : 0;
        }

        function updateCategoryIssueCounts(audit, performance) {
            var counts = {
                aeo: countGroupIssues(audit.aeo),
                structure: countGroupIssues(audit.base),
                content: countGroupIssues(audit.content),
                social: countGroupIssues(audit.social),
                speed: countGroupIssues(performance.mobile) + countGroupIssues(performance.desktop)
            };
            vm.resultTabs.forEach(function (tab) {
                if (tab.value !== 'overview') {
                    tab.count = counts[tab.value] || 0;
                }
            });
        }

        function resetCategoryIssueCounts() {
            vm.resultTabs.forEach(function (tab) {
                delete tab.count;
            });
        }

        function countGroupIssues(group) {
            var total = 0;
            if (!group || !group.exams) {
                return total;
            }
            angular.forEach(group.exams, function (exam) {
                if (exam && angular.isArray(exam.problems)) {
                    total += exam.problems.length;
                }
            });
            return total;
        }

        function startLoadingAgent() {
            stopLoadingAgent();
            vm.loadingAgentMessages = vm.loadingAgentChecks.map(function (exam, index) {
                return {
                    id: index,
                    exam: exam,
                    active: index === loadingAgentActiveRow,
                    done: index < loadingAgentActiveRow
                };
            });
            loadingAgentStep = loadingAgentActiveRow;
            vm.loadingAgentOffset = 0;
            loadingAgentTimer = $interval(advanceLoadingAgentMessage, 650);
        }

        function advanceLoadingAgentMessage() {
            if (loadingAgentStep >= vm.loadingAgentMessages.length - 1) {
                stopLoadingAgent();
                return;
            }

            vm.loadingAgentMessages[loadingAgentStep].active = false;
            vm.loadingAgentMessages[loadingAgentStep].done = true;
            loadingAgentStep += 1;
            vm.loadingAgentMessages[loadingAgentStep].active = true;
            vm.loadingAgentOffset = loadingAgentActiveRow * loadingAgentRowHeight
                - loadingAgentStep * loadingAgentRowHeight;
        }

        function stopLoadingAgent() {
            if (loadingAgentTimer) {
                $interval.cancel(loadingAgentTimer);
                loadingAgentTimer = null;
            }
        }

        $scope.$on('$destroy', function iVeBeenDismissed() {
            stopLoadingAgent();
        });

    }


    SEOCheckerResultsCtrl.$inject = ['__env', 'FavIconService','$rootScope', 'stLimitMessage', '$scope', '$window', '$state', '$timeout', '$interval', '$stateParams', 'SeocheckerService', 'ReportPdfService', 'userInfo', 'LanguageService', 'TrackEventService', '$mdMedia'];
    return SEOCheckerResultsCtrl;
});
